module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/103B4e/tc-custom/FC-9781528979917.jpg?1685327561189?1731166563089",
      "alt": "This image is the cover for the book James Grant"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("James Grant\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This story of James Grant, his family and the class they belong to is not of our time. That class still exists and its prosperity is unabated. But its position in the American national psyche is greatly diminished, its glitter dulled by the passage of time – and a change in the mores of society as a whole. But I have written it because I believe the foibles of the human heart and its redeeming strengths possess a universality which overcomes the angst of changing times. I have set the stage in an unfamiliar time to mine. Whether my characters that stride upon that cluttered stage would remain credible in a stark, modern setting, I cannot judge. I had no one in particular in mind in devising them. They are as the ghosts that populate our dreams – a compendium of hints and reflections of those who have crossed our consciousness in the ill-remembered past.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stanislas M. Yassukovich\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The author is a retired investment banker who was born in France of a White Russian émigré father and a French mother. He grew up and was educated in the United States – at Deerfield Academy and Harvard College. He pursued a distinguished career in the City of London, and then lived in France for many years. He now lives in South Africa. He has published two books: Two Lives, a Social & Financial Memoir in 2017, and Lives of the Luberon in 2019. He is married and has three children.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0